import React from "react";
import "../css/Home5.css";

const Home5 = () => {
  return (
    <div className="home5">

      {/* ======================================================
          SECTION 1 — EARTH RING HERO (enhanced)
      ======================================================= */}
      <section className="earth-hero">

        <div className="earth-rings" aria-hidden="true">
          <div className="ring r1"></div>
          <div className="ring r2"></div>
          <div className="ring r3"></div>
        </div>

        <div className="hero-center">
          <div className="hero-media">
            <img
              src="https://images.pexels.com/photos/3823063/pexels-photo-3823063.jpeg"
              alt="earthfit hero"
            />
            <div className="leaf-shadow" aria-hidden="true"></div>
          </div>

          <div className="hero-copy">
            <div className="eyebrow">EARTHFIT</div>
            <h1>Strength Rooted In Nature</h1>
            <p>
              Train slow. Move deep. Grow naturally — a grounded approach to
              fitness inspired by Earth's calm rhythm.
            </p>
          </div>
        </div>

      </section>


      {/* ======================================================
          SECTION 2 — PEBBLE TRACK (side-scrolling stones)
      ======================================================= */}
      <section className="pebble-track">
        <h2>Follow Your Path</h2>

        <div className="pebble-row" role="list">
          <div className="pebble" role="listitem">
            <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" alt="Functional Strength"/>
            <h3>Functional Strength</h3>
          </div>

          <div className="pebble" role="listitem">
            <img src="https://images.pexels.com/photos/4327033/pexels-photo-4327033.jpeg" alt="Mobility Flow"/>
            <h3>Mobility Flow</h3>
          </div>

          <div className="pebble" role="listitem">
            <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" alt="Mindful Breath"/>
            <h3>Mindful Breath</h3>
          </div>

          <div className="pebble" role="listitem">
            <img src="https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg" alt="Natural Conditioning"/>
            <h3>Natural Conditioning</h3>
          </div>

          <div className="pebble" role="listitem">
            <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" alt="Grounded Balance"/>
            <h3>Grounded Balance</h3>
          </div>
        </div>
      </section>


      {/* ======================================================
          SECTION 3 — EARTH RIPPLE CARDS (fixed + accessible)
      ======================================================= */}
      <section className="ripple-section">
        <h2>Move With Intention</h2>

        <div className="ripple-grid">
          <article className="ripple-card">
            <h3>Earth Energy</h3>
            <p>Training shaped by slow strength, control, and grounded motion for long-term resilience.</p>
          </article>

          <article className="ripple-card">
            <h3>Natural Breath</h3>
            <p>Breathing patterns that guide your movement, recovery, and focus through each session.</p>
          </article>

          <article className="ripple-card">
            <h3>Deep Awareness</h3>
            <p>Reconnect with the body via intentional cues, precise alignment, and mindful tempo.</p>
          </article>
        </div>
      </section>


      {/* ======================================================
          SECTION 4 — STACKED EARTH PANORAMAS
      ======================================================= */}
      <section className="stacked-earth">
        <div className="earth-block">
          <img src="https://images.pexels.com/photos/3757376/pexels-photo-3757376.jpeg" alt="Train in Harmony"/>
          <div className="earth-block-text">
            <h3>Train in Harmony</h3>
            <p>Strength training rooted in breath and form, not rush.</p>
          </div>
        </div>

        <div className="earth-block">
          <img src="https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" alt="Move Like Nature"/>
          <div className="earth-block-text">
            <h3>Move Like Nature</h3>
            <p>Everything flows, curves, expands — so should your training.</p>
          </div>
        </div>

        <div className="earth-block">
          <img src="https://images.pexels.com/photos/3822688/pexels-photo-3822688.jpeg" alt="Grow Steadily"/>
          <div className="earth-block-text">
            <h3>Grow Steadily</h3>
            <p>Sustainable training that evolves with your rhythm.</p>
          </div>
        </div>
      </section>


      {/* ======================================================
          SECTION 5 — EARTHQUOTE PANEL
      ======================================================= */}
      <section className="earth-quote">
        <blockquote>“Strength comes from roots — the deeper they grow, the higher you rise.”</blockquote>
      </section>


      {/* ======================================================
          SECTION 6 — SOFT CTA (no buttons)
      ======================================================= */}
      <section className="earth-cta">
        <h2>Ground Yourself In Movement</h2>
        <p>A space to breathe, move, and return to your natural rhythm.</p>

        <div className="cta-soil s1" aria-hidden="true"></div>
        <div className="cta-soil s2" aria-hidden="true"></div>
      </section>

    </div>
  );
};

export default Home5;
